interface Params {
  isCompleted: boolean;
  isInvalid: boolean;
  invalidText?: string; // Made optional for better flexibility
  isExpiring: boolean;
  expiringText?: string; // Made optional for better flexibility
  text: string;
}

/**
 * Returns the appropriate callout message based on the provided parameters.
 * Priority:
 * 1. If `isCompleted`, return the completed message.
 * 2. If `isInvalid` and `invalidText` exists, return `invalidText`.
 * 3. If `isExpiring` and `expiringText` exists, return `expiringText`.
 * 4. Otherwise, return the default `text`.
 */
export const getCalloutMessage = ({
  isCompleted,
  isInvalid,
  invalidText,
  isExpiring,
  expiringText,
  text,
}: Params): string => {
  if (isCompleted) {
    return 'Homeowner to-do has been assigned.';
  }

  if (isInvalid && invalidText) {
    return invalidText;
  }

  if (isExpiring && expiringText) {
    return expiringText;
  }

  return text;
};
